import BaseService from "../baseService";
class ContabizacaoPadrao extends BaseService {
  constructor(id) {
    const resource = "contabilizacao-padrao";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new ContabizacaoPadrao(id);
